import { render, staticRenderFns } from "./ReservationsList.vue?vue&type=template&id=f6090ce2&scoped=true"
import script from "./ReservationsList.vue?vue&type=script&lang=js"
export * from "./ReservationsList.vue?vue&type=script&lang=js"
import style0 from "./ReservationsList.vue?vue&type=style&index=0&id=f6090ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6090ce2",
  null
  
)

export default component.exports